import { PreloadableRouteObject, TFileToRouteMap } from '~/app/models'
import { getRoutesFromMap } from '~/app/utils/lazy'
import { EAdminPortalClientPath } from '~/models/api'

const createUpdatePartnerImport = () =>
  import('~/features/admin/components/partner/createUpdate')

const adminPortalRoutesFileToRouteMap: TFileToRouteMap = {
  adminAgent: {
    path: EAdminPortalClientPath.agent,
    getImportPromise: () => import('~/pages/admin/adminAgentPage'),
  },
  adminHomePage: {
    path: EAdminPortalClientPath.admin,
    getImportPromise: () => import('~/pages/admin/adminHomePage'),
  },
  adminPartnerManagementPage: {
    path: EAdminPortalClientPath.partnerManagement,
    getImportPromise: () => import('~/pages/admin/adminPartnerManagementPage'),
  },
  adminPartnerManagementCreate: {
    path: EAdminPortalClientPath.partnerCreate,
    getImportPromise: createUpdatePartnerImport,
  },
  adminPartnerManagementEdit: {
    path: EAdminPortalClientPath.partnerEdit,
    getImportPromise: createUpdatePartnerImport,
  },
  adminReferralsPage: {
    path: EAdminPortalClientPath.referrals,
    getImportPromise: () => import('~/pages/admin/adminReferralsPage'),
  },
  adminReportsPage: {
    path: EAdminPortalClientPath.reports,
    getImportPromise: () => import('~/pages/admin/adminReportsPage'),
  },
  adminTemplatesPage: {
    path: EAdminPortalClientPath.templates,
    getImportPromise: () => import('~/pages/admin/adminTemplatesPage'),
  },
  adminUserPage: {
    path: EAdminPortalClientPath.user,
    getImportPromise: () => import('~/pages/admin/adminUserPage'),
  },
  adminPromptMetadataPage: {
    path: EAdminPortalClientPath.promptMetadata,
    getImportPromise: () => import('~/pages/admin/adminPromptMetadataPage'),
  },
}

const adminPortalRoutes: PreloadableRouteObject[] = getRoutesFromMap(
  adminPortalRoutesFileToRouteMap,
)

export default adminPortalRoutes
